// src/components/Auth/PasswordField.jsx
import React, { useState, forwardRef } from "react";
import { Input } from "antd";
import { EyeInvisibleOutlined, EyeOutlined } from "@ant-design/icons";

/**
 * Поле пароля с переключателем видимости.
 *
 * Props:
 *  - value, onChange, onBlur
 *  - placeholder, className
 *  - name="new-password", autoComplete="password"
 *  - id, disabled, readOnly, size, maxLength, allowClear, onPressEnter
 */
const PasswordField = forwardRef(
    (
        {
            value,
            onChange,
            onBlur,
            placeholder,
            className = "h-[44px] rounded-[12px]",
            name = "new-password",
            autoComplete = "new-password",
            id,
            disabled,
            readOnly,
            size,
            maxLength,
            allowClear = false,
            onPressEnter,
        },
        ref
    ) => {
        const [visible, setVisible] = useState(false);

        return (
            <div className="relative">
                <Input
                    ref={ref}
                    id={id}
                    type={visible ? "text" : "password"}
                    name={name}
                    autoComplete={autoComplete}
                    placeholder={placeholder}
                    value={value}
                    onChange={onChange}
                    onBlur={onBlur}
                    className={className}
                    disabled={disabled}
                    readOnly={readOnly}
                    size={size}
                    maxLength={maxLength}
                    allowClear={allowClear}
                    onPressEnter={onPressEnter}
                />

                <button
                    type="button"
                    className="absolute right-2 top-1/2 -translate-y-1/2 h-7 w-7 rounded-full grid place-items-center bg-transparent border-0"
                    aria-label={visible ? "Hide password" : "Show password"}
                    aria-pressed={visible}
                    onMouseDown={(e) => e.preventDefault()} // чтобы не терять фокус инпута
                    onClick={() => setVisible((v) => !v)}
                >
                    {visible ? <EyeInvisibleOutlined /> : <EyeOutlined />}
                </button>
            </div>
        );
    }
);

export default PasswordField;
